export default defineNuxtPlugin(nuxtApp => {
  const store = useStore();
  const locale = process.env.APP_LOCALE || 'es';

  const fetchData = async dataMapping => {
    try {
      return await Promise.all(
        Object.entries(dataMapping).map(([key, action]) =>
          callOnce(key, () => store.dispatch(`strapi/${action}`, locale))
        )
      );
    } catch (error) {
      console.error('Error fetching data:', error);
    }
  };

  const dataGroups = {
    critical: {
      common: 'getCommons',
      process: 'getProcess',
      sectors: 'getSectors'
    },
    secondary: {
      subSectors: 'getSubsectors'
    }
  };

  nuxtApp.hook('app:created', async () => {
    await fetchData(dataGroups.critical);
  });

  nuxtApp.hook('app:mounted', async () => {
    await fetchData(dataGroups.secondary);
  });
});
